import { useAtom } from 'jotai'
import { purchaseTypeAtom } from '@!/atoms/paymentAtom'
import { Box, HStack, Text, Divider, Button } from '@chakra-ui/react'
import { PaymentHeader } from '@!/User/Payment/components'
import NoticeList from '@!/User/Payment/components/MonthlyCourse/NoticeList'
import CoinSubmitButton from './CoinSubmitButton'
import MonthlySubmitButton from './MonthlySubmitButton'

export const PaymentForm = ({ newCardToken, currentCard, handleSubmit, onChangeCard, restore = false }) => {
  const [purchaseType] = useAtom(purchaseTypeAtom)

  return (
    <>
      <PaymentHeader />
      {!newCardToken && (
        <>
          <HStack w="100%" p="4" justify="space-between">
            <Text fontWeight="bold">前回使用したカード</Text>
            <Button size="xs" fontSize="2xs" onClick={onChangeCard}>
              他のカードを使う
            </Button>
          </HStack>
          <Divider />
        </>
      )}

      <HStack w="100%" justify="space-between" p="4" fontSize="2xs">
        <Text>クレジットカード番号</Text>
        <Text>{currentCard?.number}</Text>
      </HStack>

      <Divider />

      {purchaseType === 'monthly' && <NoticeList restore={restore} />}

      <Box w="100%" p="4">
        {purchaseType === 'coin' ? <CoinSubmitButton handleSubmit={handleSubmit} /> : <MonthlySubmitButton handleSubmit={handleSubmit} restore={restore} />}
      </Box>
    </>
  )
}
